import { render } from "./KoruExpiration.vue?vue&type=template&id=cae2fea6&ts=true"
import script from "./KoruExpiration.vue?vue&type=script&lang=ts"
export * from "./KoruExpiration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__